import { createSelector } from 'reselect';
import { STATE_NAME } from './constants';

export const getStateSlice = state => state.get(STATE_NAME);

export const getMarketSettingsMap = state =>
  getStateSlice(state).get('marketsettings');

export const getFeedback = createSelector(
  getMarketSettingsMap,
  feedbackMap => feedbackMap.toList()
);

export const getMarketSettings = state =>
  getStateSlice(state).get('marketsettings');

export const getIsFetching = state => getStateSlice(state).get('isFetching');
export const getFetchError = state => getStateSlice(state).get('fetchError');
